import React, { useState, useEffect } from "react";
import "./OrgChart.css";
import useApi from "../../../../core/customhook/useApi";
import { Link } from "react-router-dom";

// OrgNode receives props from OrgChart
const OrgNode = ({ node, onCardClick }) => {
  console.log(node)
  const [expanded, setExpanded] = useState(false);
  const hasChildren = node.children && node.children.length > 0;

  return (
    <li
      className={`org-node ${hasChildren ? "has-children" : ""} ${expanded ? "expanded" : ""
        }`}
    >
      <div className="node">
        <div
          className="Org_card"
          onClick={() =>
            onCardClick({
              id: node.employee_id,
              name: node.name,
              title: node.title,
              department: node.department,
              img:
                node.img ||
                "https://cdn-icons-png.flaticon.com/512/149/149071.png",
            })
          }
        >
          <img
            src={
              node.img ||
              "https://cdn-icons-png.flaticon.com/512/149/149071.png"
            }
            alt={node.name}
            className="node-img"
          />
          <div className="node-info">
            <h6>{node.name}</h6>
            <small>{node.title} </small>
            <small>{node.department}</small>
            {/* <small>sofotwre</small> */}
          </div>
        </div>
        {hasChildren && (
          <span
            className={expanded ? "toggle-btnMinuse" : "toggle-btnPlus"}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? "−" : "+"}
          </span>
        )}
        {hasChildren && expanded && <div className="arrow-down">&darr;</div>}
      </div>

      {hasChildren && expanded && (
        <ul>
          {node.children.map((child, idx) => (
            <OrgNode key={idx} node={child} onCardClick={onCardClick} />
          ))}
        </ul>
      )}
    </li>
  );
};

const OrgChart = () => {
  const [data, setData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [userData, setUserData] = useState({});

  

  const {
    data: orgChartData,
    loading: orgChartLoading,
    error: orgChartError,
  } = useApi("/api/manager/employee-team-member", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (orgChartData?.success) {
      console.log("Org Chart Root Node:", orgChartData?.data[0]);
      setData(orgChartData?.data[0]);
    }
  }, [orgChartData])
  // Handle modal open
  const handleCardClick = (user) => {
    setUserData(user);
    setShowModal(true);
  };

  return (
    <>
      <div id="orgChart" className="organization1">
        <div className="org-chart-wrapper">
          <div className="chart-parent" id="org-chart">
            <div className="chart-container">
              <ul className="tree">
                <OrgNode node={data} onCardClick={handleCardClick} />
              </ul>
            </div>
          </div>
        </div>

        {/* Modal */}
        {showModal && (
          <div
            className="modal-overlay"
            role="dialog"
            aria-modal="true"
            onClick={() => setShowModal(false)}
          >
            <div className="modal-box" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={() => setShowModal(false)}>
                ×
              </button>
              <img
                src={userData.img}
                alt={userData.name}
                className="modal-img"
              />
              <h4>{userData.name}</h4>
              <p>{userData.department}</p>
              <p>{userData.title}</p>
              <p>
                <Link to={`/pages/profile/${userData.id}`} className="btn btn-secondary">View Profile</Link>
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default OrgChart;
